import { Player } from "../generated/graphql";

const getPlayerName = (player?: Player) =>
  `${player?.firstName} ${player?.lastName}`;
export default getPlayerName;
